import React from "react";
import { useTranslation } from "react-i18next";
import "./Footer.css";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <>
      <footer>
        <div className="container grid">
          <div className="box">
            <h2>{t("join")}</h2>
            <p>
              {t("update")} <br /> {t("updateNext")}
            </p>
            <input
              type="email"
              placeholder={t("placeholder")}
              className="white-text-input"
              name=""
              id=""
            />
            <input
              type="button"
              className="primary-btn"
              value={t("subscribe")}
            />
          </div>
          <div className="box">
            <span>{t("visitLocation")}</span>
            <p>{t("street")}</p>
          </div>
          <div className="box" style={{ marginTop: "12px" }}>
            <span>Contact Us Anytime</span>
            <p>{t("sharaNumber")}</p>
            <p>
              {t("orSendEmail")} <br />
              <a href="mailto:shara@gmail.com" className="email-link">
                {t("sharaMail")}
              </a>
            </p>
          </div>
        </div>
      </footer>
      <div className="legal">
        <p>© 2024 {t("copyrights")}</p>
      </div>
    </>
  );
};

export default Footer;
